import { Box, CssBaseline } from "@mui/material";
import React, { useState, useEffect } from "react";
import DashboardAppbar from "./DashboardAppbar";
import DashboardContent from "./DashboardContent";
import DashboardDrawer from "./Drawer/DashboardDrawer";
import { QuickAccessItems } from "../Models/Common";
import { useMicrospecDynamicUIContext } from "../GlobalProvider";
import { useMicrospecThemeLanguageContext } from "../Themes";

const drawerWidth = 280; // Increased for better spacing

interface DashboardProps {
  application: any;
  dashboard: any;
  parent?: any;
  item: any;
  organizationContextAware: boolean;
  computeQuickAccessItems?: (cloudProvider: any, localizationProvider: any, setQuickAccessItems: React.Dispatch<React.SetStateAction<QuickAccessItems>>, setQuickAccessItemsRetrieved: React.Dispatch<React.SetStateAction<boolean>>) => Promise<void>;
}

const Dashboard: React.FC<DashboardProps> = ({ application, dashboard, parent, item, organizationContextAware, computeQuickAccessItems }) => {
  const [quickAccessItems, setQuickAccessItems] = useState<QuickAccessItems>([]);
  const [quickAccessItemsRetrieved, setQuickAccessItemsRetrieved] = useState<boolean>(false);
  const [mobileOpen, setMobileOpen] = useState<boolean>(false);
  const { cloudProvider } = useMicrospecDynamicUIContext();
  const { localizationProvider } = useMicrospecThemeLanguageContext();

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  useEffect(() => {
    const loadQuickAccessItems = async () => {
      if (computeQuickAccessItems && !quickAccessItemsRetrieved) {
        try {
          await computeQuickAccessItems(
            cloudProvider,
            localizationProvider,
            setQuickAccessItems,
            setQuickAccessItemsRetrieved
          );
        } catch (error) {
          console.error("Failed to compute quick access items:", error);
          setQuickAccessItemsRetrieved(true);
        }
      }
    };

    loadQuickAccessItems();
  }, [cloudProvider, localizationProvider, quickAccessItemsRetrieved, computeQuickAccessItems]);

  return (

    <Box
      sx={{
        display: "flex",
        minHeight: "100vh",
        backgroundColor: (theme) => theme.palette.mode === 'dark'
          ? 'linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%)'
          : 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
        backgroundAttachment: 'fixed'
      }}
    >
      <CssBaseline />
      <DashboardAppbar data={{
        application,
        dashboard,
        handleDrawerToggle,
        item,
        organizationContextAware,
        quickAccessItems
      }} />
      <DashboardDrawer
        data={{
          handleDrawerToggle,
          mobileOpen,
          application,
          dashboard,
          parent,
          item,
          organizationContextAware
        }}
      />
      <DashboardContent data={{
        organizationContextAware,
        dashboard,
        item,
        quickAccessItems
      }} />
    </Box>
  );
};

export default Dashboard;
export { drawerWidth };

